import { useState } from 'react';

const usePeriodoSelectionModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const open = (reportData) => {
    const hoje = new Date();
    const anoBase = parseInt(localStorage.getItem('anoBase')) || hoje.getFullYear();
    const dataInicio = `${anoBase}-01-01`;
    const dataFim = `${anoBase}-12-31`;

    setData({
      ...reportData,
      dataInicio,
      dataFim,
    });
    setIsOpen(true);
    setIsLoading(false);
  };

  const close = () => {
    setIsOpen(false);
    setData(null);
    setIsLoading(false);
  };

  const confirm = () => {
    close();
  };

  const updateDatas = (dataInicio, dataFim) => {
    setData(prev => ({ ...prev, dataInicio, dataFim }));
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  return {
    show: isOpen,
    data,
    open,
    close,
    confirm,
    updateDatas,
    isLoading,
    setLoading,
  };
};

export default usePeriodoSelectionModal;
